import { PathLayer, PathLayerProps } from "@deck.gl/layers"
import { DataFilterExtension } from "@deck.gl/extensions"

type FlightPathsLayerDataType = {
    id: string
    path: [number, number, number][]
    name?: string
}

type _FlightPathsLayerProps = {
    getFilterValue: () => number
    filterRange?: [number, number]
}

type FlightPathsLayerProps<DataType = FlightPathsLayerDataType> = PathLayerProps<DataType> &
    _FlightPathsLayerProps

const defaultProps = {
    pickable: true,
    widthScale: 1,
    widthMinPixels: 2,
    widthMaxPixels: 2,
    getPath: (d: unknown) => {
        return (d as FlightPathsLayerDataType).path
    },
    extensions: [new DataFilterExtension({ filterSize: 1 })],
    filterRange: [1, 1],
}

export default class FlightPathsLayer<
    DataType = FlightPathsLayerDataType,
    ExtraPropsType extends PathLayerProps<DataType> = FlightPathsLayerProps<DataType>,
> extends PathLayer<DataType, ExtraPropsType> {
    static defaultProps = defaultProps
    static layerName = "FlightPathsLayer"
}
